

const About = ()=>{
    return(
        <section id='about' className=" hid p-2 m-4">
            <h1 className="header">ABOUT-ME</h1>
            <div className=" md:grid md:grid-cols-3 md:gap2 p-4">
                <div className="col-span-1 delay-700 md:animate-bounce-slow"><img className="h-20 md:h-48 m-auto outline outline-2 outline-offset-1 md:outline-4 md:outline-offset-2 outline-purple-500 rounded-full  " src='/img/profile.jpeg' alt="pic" /></div>
                
                <div className="col-span-2 text-sm p-1"><p>I am a web developer passionate about creating seamless pixel-perfect interfaces and experiences on the web while ensuring maximum accessibility 
                and user-friendliness. I specialize in building elegant, intuitive & highly optimized web applications that effectively provide information and services to their intended
                consumers using modern technologies and best practices. I am a graduate of Computer Science from the University of Jos, I have always been intrigued by the concept of using technology to solve real world problems as I come from a rich agricultural background.
                I enjoy watching movies, reading books, and having random insightful conversations with strangers where I learn more about the world from different perspectives, my greatest skill/strengths include:<br/>
                -The ability to communicate efficiently and work with diverse groups of people, overall being a great team member.
                <br/>-Being solution driven and able to visualize solutions before even writing down lines of code as I believe codes and programming languages are only tools ment to carry out predefined operations.</p>
                <div className="flex justify-center mt-2">
                <a href="/ao.docx" download="abimikuoshelaCV.docx" className="text-white rounded-md  py-2 px-2 bg-gradient-to-r from-indigo-800 via-purple-900 to-purple-900">Download Resume</a>
   
                </div>
                                    </div>
            </div>
           
            </section>
    )
}
export default About;